import React, { Component } from 'react';
import _ from 'lodash';
import Notif from '../../../commonModules/interface/Notif';
import Dialog, { CalendarDialog } from '../../../commonModules/interface/Dialog';
import { isEmpty } from "lodash";
import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet
import { LineChart } from '../PaygChart';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchInstallers ,fetchAgents} from '../../../../../../jsx/actions/paygAction';
import { newRecoveryAction } from '../../../../../../jsx/actions/recoveryAction';
import {  TableBody, TableRow, TableHead,TableCell, Grid, Box,  Button } from '@material-ui/core';
import TabsContent from '../../../commonModules/interface/TabsContent';
import InputText, { TextArea } from '../../../commonModules/interface/form-input-inline';
import { PhoneAndroidRounded, AddAlert, CommentRounded, AddIcCallRounded, AddAlertRounded, ReportRounded,DirectionsRunRounded, PersonRounded, CallEndSharp, CallMadeRounded, CallMissedRounded, CloseOutlined, CloseRounded, CallRounded, CallEndRounded, PhoneForwardedRounded, PhoneMissedRounded } from '@material-ui/icons';
import { TableLayout } from '../Stock/containers/Layout';
import { Alert, Timeline } from '@material-ui/lab';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import { TimeLineBlock } from '../../../commonModules/interface/TimeLineMui';
import ActionForms from '../Recovery/Forms/ActionForms';
import CardButton from '../../../commonModules/interface/CardButton';


const ICONTYPE = {
    "alert": { icon : <AddAlertRounded /> }, 
    "operator": { icon : <PersonRounded />, color: "lightPink"},
    "comment": { icon : <CommentRounded />, color: "lightGreen"}, 
    // "comment": { icon : <CommentRounded />, color: "lightseagreen"}, 
    // "call": { icon : <PhoneForwardedRounded />, color: "dodgerblue"},
    "call": { icon : <PhoneForwardedRounded />, color: "lightBlue"},
    "missCall": { icon : <PhoneMissedRounded />, color: "deepOrange"},
    "end": { icon : <CloseOutlined />, color: "black"},
    // "call": { icon : <CallMadeRounded />,
    // "missCall": { icon : <CallMissedRounded />,
    "done": { icon : <CloseRounded />, color:"primary"},
}
// const ICONTYPE = {
//     "operator": {icon: <PersonRounded />, title: "Gestionnaire"},
//     "comment": {icon: <CommentRounded />, title: "Commentaire"}, 
//     "alert": {icon: <AddAlertRounded />, title: "Alerte"}, 
//     "call": {icon: <CallMadeRounded />, title: "Appel"},
//     "missCall": {icon: <CallMissedRounded />, title: "Appel sans Réponse"},
//     "end": {icon: <CloseOutlined />, title: "Fin Contrat"},
//     "done": {icon: <CloseRounded />, title: "Résolu"},
// }

const Today = new Date()
class SuiviRecovery extends React.PureComponent {
    state = {
        messagesIdList: [],
        subHeaderMenu: this.props.home ? "SUIVI" : "ACTIONS",
        callForm: false,
        commentForm: false,
        alertForm: false,
        endContractForm: false,
        requestCommercialHelp: false,
        dialog:false,
        history:[],
        paymentList:[],
        commentList: [],
        callList: [],
        alertList: [],
        missCall: 0,
        recoveryAmount: 0,
        recoveryKm: 0,
        
        answer:"",
        comment:"",
        actionAlert:"",
        dateAlert:"",
        callLength:"",
        fullDate:"",
        openCalendar:false,
        alertDone:"",
        agent: "",
        
        errors:{
            answer:"",
            comment:"",
            actionAlert:"",
            dateAlert:"",
            callLength:"",
            alertDone:"",
        },
        info:{
            last: "",
            nextStop: "",
            period: "",
            delay: "",
            totalPeriods: "",
            totalLate:"",
        },
        notif:{
            title:"", 
            type:"", 
            message:"",
            show:false,
        },
        historyLength: 0,
    }
    
    componentDidMount = () => {
        if (!this.props.recoveryIDList){
            this.getUserHistory()
        } else {
            this.setState({
                history: this.props.recoveryIDList
            })
        }
        this.getPaymentsList()
        if (!this.props.INSTALLERS){
            this.props.fetchInstallers();
        }
        if (!this.props.AGENTS){
            this.props.fetchAgents();
        }
    }
    getPaymentsList = () => {
        const { PAYMENTS, paymentsIDList } = this.props
        let payment_info_list = []
        paymentsIDList.map( ID => {
            if(PAYMENTS[ID] && PAYMENTS[ID].typePayment !== 'gift'){
                payment_info_list.push(PAYMENTS[ID])
            }
        })
        this.setState({
            paymentList: payment_info_list
        })
        
    }
    totalLate = (totalLate) => {
        console.log("TOTAL LATE ", {totalLate});
        if (this.state.info.totalLate === ""){
            this.setState({
                info:{
                    ...this.state.info,
                    totalLate
                }
            })
        }
    }
    getUserHistory = async  () => {
        try{
            const response = await fetch("/recovery/user/history", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    clientID: this.props.boxAssoId,
                    // clientID: this.props.userID || this.props.paygoID,
                }),
                credentials: 'same-origin',
            });
            const res = await response.json();
            const commentList = []
            const callList = []
            const alertList = []
            let missCall = 0
            let historyList = res.recoveryList || []
            historyList = ( historyList.length > 0 ? historyList.reverse() : historyList)
            // res.recoveryList.map(action =>{
            //     if(action.nature === 'Comment'){
            //         commentList.push(action)
            //     } else
            //     if(action.nature === 'Call'){
            //         callList.push(action)
            //         if(action.answer === false){
            //             missCall +=1
            //         }
            //     } else
            //     if(action.nature === 'Alert'){
            //         alertList.push(action)
            //     }
            // })
            this.props.getClientRecoveryActions(this.props.boxAssoId, historyList)
            this.setState({
                history: historyList,
                historyLength: historyList.length > 10 ? 10 : historyList.length,
                commentList,
                callList,
                alertList,
                missCall
            })
            // console.log('IN popupInfo getUserHistory request ', {res});
        } catch (err) {
            console.log(err);
        }
    }
     
    handleChange = (e) => {
        const regex = /^[0-9\b]+$/ // int only
        const name = e.target.name 
        const value = e.target.value 
        if(name ==='callLength'){
            if(value ==="" || regex.test(value)){
                this.setState({
                    [name]: value
                })
            }   
        } else {

            this.setState({
                [name]: value
            })
        }
    }
    handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        this.setState({
            dateAlert: selectedDate,
            openCalendar:false
        })
        this.displayDate(selectedDate)
    }
    displayDate = (datetime) => {
        const WEEKDAYS = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"]
        const MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        let weekday = WEEKDAYS[datetime.getDay()]
        let date = datetime.getDate()
        let month = MONTHS[datetime.getMonth()]
        let year = datetime.getFullYear()

        // console.log({date, weekday, month, year});
        const fullDate = (weekday +' '+ date +' '+ month +' '+ year)
        // console.log({fullDate});
        // return fullDate
        this.setState({
            fullDate
        })

    }

    validate = () => {
        
        const { userInfo } = this.props
        const { alertForm, callForm, commentForm } = this.state
        const required = ['comment']
        if(userInfo.activeAlert && (callForm || commentForm)){
            required.push('alertDone')
        }
        const alert = ['dateAlert', 'actionAlert']
        const call = ['answer']
        const errors = {}
        let noErrors = true
        required.map( field => {
            if (this.state[field] === ""){
                errors[field] = 'Veuillez remplir ce champ'
                noErrors = false
            } else {
                errors[field]= ''
            }
        })
        if(alertForm){
            alert.map( field => {
                if (!this.state[field]){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
        }
        if(callForm){
            call.map( field => {
                if (this.state[field] === ""){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
        }
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors});
        
        return noErrors
    }
    formatData = async () => {
        
        const {dateAlert, agent,actionAlert, recoveryKm  ,recoveryAmount, comment, answer, callForm, endContractForm, alertForm, commentForm, callLength,requestCommercialHelp } = this.state
        
        let formData = {
            comment
        }
        let nature = '';
        
        if (callForm) {
            nature = "Call";
            formData.callLength = parseInt(callLength);
            formData.answer = answer === "oui";
        } else if (commentForm) {
            nature = "Comment";
            
        } else if (alertForm){ 
            nature = "Alert";
            formData.date = dateAlert;
            formData.action = actionAlert;
        } else if (endContractForm) {
            nature = "End";
        } else if (requestCommercialHelp){
            nature = "ExternalAction";
            formData.km = parseFloat(recoveryKm)
            formData.amount = parseFloat(recoveryAmount)
            formData.action = actionAlert
            formData.agent = agent
        }
        
        console.log({formData});
        let formBody = []
        formBody.push({
            id: 0,
            nature,// call, comment ...
            formData,
        })
        if(this.state.alertDone === "oui"){
            console.log("HAS ALERT DONE");
            formBody.push({nature:'Done', id :1, formData:{}})
        }

        return formBody

    } 
    handleSubmit = async () => {
        if(this.validate()){
            try {
                const formBody = await this.formatData()
                console.log({formBody});
                
                // const res = await fetch('/recovery/new',{
                //     method:'POST',
                //     headers: {
                //         'Content-Type': 'application/json',
                //         //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                //     },
                //     body: JSON.stringify({
                //         boxAssoId : this.props.boxAssoId,
                //         // clientID : this.props.userID || this.props.paygoID,
                //         actionList: formBody
                //     }),
                //     credentials: 'same-origin',
                // })
                // const result = await res.json()
                // console.log({result} , result.errorCode);

                await this.props.newRecoveryAction(formBody, this.props.boxAssoId)
                if (!this.props.STATE.error){
                    this.clearForms()
                    this.notif("info","Action enregistrée avec succès")
                } else {
                    console.log('====================================');
                    console.log(this.props.STATE.error);
                    console.log('====================================');
                    this.notif("danger", `Un problème est survenu: ${this.props.STATE.error}`)
                }
            } catch (error) {
                console.log(error);
                
            }
        } else {
            console.log("errors in form");
            
        }
    }
    clearForms = () =>{
        console.log("CLEAR");
        this.getUserHistory()
        this.setState({

            answer:"",
            comment:"",
            actionAlert:"",
            dateAlert:"",
            callLength:"",
            fullDate:"",
            openCalendar:false,
            dialog:false,
            callForm: false,
            commentForm: false,
            alertForm: false,
            endContractForm: false,
            alertDone:"",

            errors:{
                answer:"",
                comment:"",
                actionAlert:"",
                dateAlert:"",
                callLength:"",
                alertDone:"",
            },  
        })
    }
    
    setTimeLine = () => {
        const { history, historyLength } = this.state;
        // Mémoïsation : la timeline ne dépend que de (history, historyLength). Sans
        // cela, chaque frappe dans un formulaire (setState comment/answer/…) faisait
        // re-render tout SuiviRecovery et reconstruisait toute la timeline MUI derrière
        // la modale. On ne recalcule que lorsque l'historique change réellement.
        if (this._timelineCache && this._timelineHistory === history && this._timelineLength === historyLength) {
            return this._timelineCache;
        }
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const rendered = history.slice(0, historyLength).map( action => {
            let type = ""
            let other = ""
            if(action.nature === 'Comment'){
                type ='comment'
            } else if(action.nature === 'InitialQualityCall'){
                type ='comment'
                let contentForms1= Object.keys(action.forms[0]).map((formKey, j) => {
                    return (
                        <TableRow key={formKey}>
                            <TableCell>{formKey}</TableCell>
                            <TableCell>{action.forms[0][formKey]}</TableCell>
                        </TableRow>
                    )
                })
                let contentForms2= Object.keys(action.forms[1]).map((formKey, j) => {
                        return (
                            <TableRow key={formKey}>
                                <TableCell>{formKey}</TableCell>
                                <TableCell>{action.forms[1][formKey]}</TableCell>
                            </TableRow>
                        )
                    })
                let tab1 =  (
                    <TableLayout >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" colSpan={2}>{"Information modifiée"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{contentForms1}</TableBody>
                    </TableLayout>
                )
                let tab2 = ( 
                    <TableLayout >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" colSpan={2}>{"Questionnaire qualité"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{contentForms2}</TableBody>
                    </TableLayout>
                )

                other = <div>{tab1}{tab2}</div>
            } else if(action.nature === 'Call'){
                if(action.answer){
                    type = 'call'
                } else {
                    type = 'missCall'
                }
            } else if(action.nature === 'End'){
                type ='end'
            } else if(action.nature === 'Alert'){
                type ='alert'
                other = ` Le ${new Date(action.date).toLocaleDateString('fr-FR', options)} `
            } else if(action.nature === 'Done'){
                action.action = 'Résolu'
                type ='done'
                other = `Alerte Désactivée`
            } else if(action.nature === 'ExternalAction'){
                type ='operator'
                switch (action.action) {
                    case 'CallClient':
                        action.action = 'Demande d\'appel du client par le commercial'
                        other = ' '
                        break;
                    case 'SeeClient':
                        action.action = 'Demande de visite du client pour le recouvrement'
                        break;
                    case 'RemoveClient':
                        action.action = 'Demande de désinstallation du client'
                        break;
                }
            }

            let step = {
                date: new Date(action.timeCreation).toLocaleString('fr-FR'),
                icon: ICONTYPE[type].icon,
                color: ICONTYPE[type].color,
                title: action.action,
                content: action.Comment,
                other: other
            }
            return(
                // {type === "done" && 
                //     <div>
                //         <hr/>
                //         <hr />
                //     </div>
                // }
                <TimeLineBlock step={step} />
            )
        })
        this._timelineHistory = history
        this._timelineLength = historyLength
        this._timelineCache = rendered
        return rendered
    }

    handleChargeMore = () => {
        const { historyLength, history } = this.state;
        let newLength = 0
        if ((history.length - historyLength) >= 10){
            newLength = 10 + historyLength
        } else if ((history.length - historyLength) > 0) {
            newLength = history.length
        }
        this.setState({
            historyLength: newLength
        })
    }
    notif = (type, msg) => {
        this.setState({
            notif: {
                title:"", 
                type, 
                message:msg,
                show:true
            }
        })
    }
    render() {
        const {userInfo} = this.props
        const { historyLength, history } = this.state;
        return (
            <Box >
                {this.state.dialog &&
                    <ActionForms 
                        {...this.state}
                        STATE={this.props.STATE}
                        AGENTS={this.props.AGENTS}
                        userInfo={userInfo}
                        handleSubmit={this.handleSubmit}
                        handleChange={this.handleChange}
                        handleChangeDate={this.handleChangeDate}
                        handleClose={() => this.setState({
                            dialog:false, 
                            callForm: false,
                            commentForm: false,
                            alertForm: false,
                            endContractForm: false,
                            requestCommercialHelp: false,
                        })}
                    />
                }
                {this.state.notif.show && // move to parent !
                    <Notif
                        show={this.state.notif.show} 
                        title={this.state.notif.title} 
                        type={this.state.notif.type} 
                        message={this.state.notif.message} 
                        close={()=> this.setState({
                            notif:{
                                ...this.state.notif,
                                show:false,
                            }
                        })} 
                    />
                }
                
                <Box>                                
                    {this.props.home ? (
                    <Box >
                        {this.state.history &&
                            // <Timeline align="alternate">
                            <Timeline>
                                {this.setTimeLine()}
                            </Timeline>
                        }
                        {historyLength < history.length &&
                            <Box style={{textAlign: "center"}}>
                                <Button 
                                    color="secondary" 
                                    disabled={historyLength === history.length} 
                                    onClick={this.handleChargeMore}
                                >
                                    Afficher plus
                                </Button>
                            </Box>
                        }
                    </Box>   
                    ) : (
                        <SwipeableTabs
                            labels={["ACTIONS", "SUIVI"]}
                            // labels={["DASHBOARD", "ACTIONS", "SUIVI"]}
                            default={this.state.subHeaderMenu}
                        >
                                {/* <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        {!isEmpty(this.state.paymentList) && 
                                            <LineChart 
                                                abo={this.props.abo}
                                                userInfo={userInfo} 
                                                paymentList={this.state.paymentList} 
                                                title="Cumul des paiements" 
                                                legendPosition="bottom" 
                                                totalLate={this.totalLate}
                                            />                                            
                                        } 
                                        {isEmpty(this.state.paymentList) &&
                                            <p>Pas Assez de Données</p>
                                        }
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box p={2} className="table-responsive">
                                            <Table className="table table-striped">
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>Nombre de Jours de retard</TableCell>
                                                        <TableCell>{this.state.info.delay}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Fréquence de Paiement</TableCell>
                                                        <TableCell>Tous les {this.props.userInfo.periodicity || 31} Jours</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Nombre de periodes de retard</TableCell>
                                                        <TableCell>{this.state.info.totalPeriods}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Montant Dû</TableCell>
                                                        <TableCell>{this.state.info.totalLate || ""} </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Date dernier appel</TableCell>
                                                        <TableCell>
                                                        {this.state.callList[this.state.callList.length].timeCreation}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Nombre Total d'Appel</TableCell>
                                                        <TableCell>{this.state.callList.length} (dont sans réponse .. )</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Dernier commentaire</TableCell>
                                                        <TableCell>{this.state.commentList[this.state.commentList.length].Comment}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </Grid>
                                </Grid> */}
                                
                                <Grid container spacing={2} className="text-center">
                                    {this.props.userInfo.activeAlert &&
                                        <Grid item xs={12}>
                                            <Alert severity="warning" >Alerte en cours</Alert>
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={6}>
                                        <CardButton
                                            title="Appel Client"
                                            action={()=>this.setState({callForm:true, dialog:true})}
                                            icon={<AddIcCallRounded style={{ color: "blue"}} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CardButton
                                            title="Ajouter une Alerte"
                                            action={()=>this.setState({alertForm:true, dialog:true})}
                                            icon={<AddAlertRounded style={{ color: "yellow"}} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CardButton
                                            title="Ajouter un Commentaire"
                                            action={()=>this.setState({commentForm:true, dialog:true})}
                                            icon={<CommentRounded style={{ color: "green"}} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CardButton
                                            title="Fin de Contrat"
                                            action={()=>this.setState({endContractForm:true, dialog:true})}
                                            icon={<ReportRounded style={{ color: "red"}} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CardButton
                                            title="Solliciter le Commercial"
                                            action={()=>this.setState({requestCommercialHelp:true, dialog:true})}
                                            icon={<DirectionsRunRounded style={{ color: "purple"}} />}
                                        />
                                    </Grid>
                                </Grid>
                            
                                {/* }
                                { this.state.subHeaderMenu === "SUIVI" &&                        */}
                                <Box>
                                    
                                    {history &&
                                        <Timeline>
                                        {/* <Timeline align="alternate"> */}
                                            {this.setTimeLine()}
                                        </Timeline>
                                    }
                                    {historyLength < history.length &&
                                        <Box style={{textAlign: "center"}}>
                                            <Button 
                                                color="secondary" 
                                                disabled={historyLength === history.length} 
                                                onClick={this.handleChargeMore}
                                            >
                                                Afficher plus
                                            </Button>
                                        </Box>
                                    }
                                </Box>                        
                                {/* } */}
                            {/* </Box> */}
                        </SwipeableTabs>
                    )} 
                </Box>
            </Box>
        );
    }
}


function mapStateToProps(state){
    return {
        INSTALLERS: state.installers,
        AGENTS: state.agents.agents,
        STATE: state.inventory.requestState.recovery,

    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        fetchInstallers,
        fetchAgents,
        newRecoveryAction,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(SuiviRecovery);